export default "__VITE_ASSET__DUd6bEbQ__"